<ng-container *transloco="let t;">
      <div class="mb-50">
        <div class="detailFirstColumn">
          <label class="col-form-label">
            {{ t('Linked with text for details (Documents Section) - Linked with') }}
          </label>
        </div>
        
        <div *ngIf="!hasLinkedContracts">
          <p class="mb-0">
            <a (click)="openContractControl()" 
               class="text-primary font-small-3 cursor-pointer">
              {{ t('Add to Contract Control text for link (Documents Section) - Add to Contract Control') }}
            </a>
          </p>
        </div>

        <div *ngIf="hasLinkedContracts">
          <p class="mb-0">
            <a class="text-primary font-small-3 cursor-pointer" 
               (click)="navigateToContract()">
              {{ contractName }}
            </a>
          </p>
        </div>
      </div>
    </ng-container>